export enum InvoiceTypes {
    TRANSPORTS = 1,
    STORAGE = 2,
    ACTIVITY = 3,
}

export const InvoiceTypeRoute = {
    [InvoiceTypes.TRANSPORTS]: 'loads',
    [InvoiceTypes.STORAGE]: 'storage',
    [InvoiceTypes.ACTIVITY]: 'activity',
}

export const InvoiceTypesList = [
    {
        id: InvoiceTypes.TRANSPORTS,
        name: 'Transports'
    },
    {
        id: InvoiceTypes.STORAGE,
        name: 'Storage'
    },
    // {
    //     id: InvoiceTypes.ACTIVITY,
    //     name: 'Activity'
    // }
]

export enum VendorInvoiceFileStatus {
    NEW = 1,
    PROCESSED = 2,
    ERROR = 3,
    FAILED = 4,
    NEEDS_ATTENTION = 5,
    MANUAL_UPLOAD = 6,
    IGNORE = 7,
}

export const VendorInvoiceFileStatusLabels = [
  { id: VendorInvoiceFileStatus.NEW, name: 'New', color: '#7FC7FF'},
  { id: VendorInvoiceFileStatus.PROCESSED, name: 'Processed', color: '#0DBF45' },
  { id: VendorInvoiceFileStatus.ERROR, name: 'Error', color: '#6111f5ff' },
  { id: VendorInvoiceFileStatus.FAILED, name: 'Failed', color: '#f16d6d' },
  { id: VendorInvoiceFileStatus.NEEDS_ATTENTION, name: 'Needs Attention', color: '#FFB533' },
  { id: VendorInvoiceFileStatus.MANUAL_UPLOAD, name: 'Manual Upload', color: '#ff33bbff' },
  { id: VendorInvoiceFileStatus.IGNORE, name: 'Ignore', color: '#0b07fdff' },
];



